import { TOGGLE_CONTACT_BAR } from '../actions/contactBar';

const initialState = {
  isHidden: false,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_CONTACT_BAR:
      return {
        ...state,
        isHidden: action.payload.hidden,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
